export default "__VITE_ASSET__864cbea7__"